import { render, staticRenderFns } from "./Realm.vue?vue&type=template&id=4cdadf52"
import script from "./Realm.vue?vue&type=script&lang=js"
export * from "./Realm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports